export const BYOD_FIELDS = [
  'UserId',
  'FullName',
  'EmployeeId',
  'EmailAddress',
  'Designation',
  'MobileNumber',
  'BankInfoJson',
  'BusinessUnitName',
  'RequestDepartmentId',
  'RequestDepartmentName',
  'DeviceModel',
  'ComputerProcessor',
  'Motherboard',
  'RamCapacity',
  'MonitorDetails',
  'HddSsdDetails',
  'Status',
  'AppliedDateUtc',
  'ApprovedBy',
  'ApprovedByName',
  'ApprovedDateUtc',
  'ApprovalStatusReason',
  'DepartmentId',
  'Timezone',
] as const;
